import { Typography } from 'antd';

import { LeadModel } from '@/typings/models/Lead';
import { useHasMarketingDataAccess } from '@/utils/hooks';

const UtmCampaign = ({lead}: {lead: LeadModel, isTable?: boolean}) => {
  const hasMarketingDataAccess = useHasMarketingDataAccess();
  const campaign = lead?.customer?.utm_campaign;

  if (!hasMarketingDataAccess) return null;
  if (!campaign) return <span>-</span>;

  // Campaign names are long enough to wrap the whole details row.
  return <Typography.Text ellipsis={{ tooltip: campaign }}>{campaign}</Typography.Text>;
}

export default UtmCampaign
